<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" i18n="@@CreatePricingHeader">Tarif hinzufügen</h5>
    <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
  </div>
  <div class="modal-body">
    <app-create-pricing [customerId]="customerId" (newEntityEvent)="newEntityEvent($event)" #createPricingComponent></app-create-pricing>
  </div>
  <div class="modal-footer">
    <button type="button" id="cancel" class="btn btn-yellow" data-bs-dismiss="modal" (click)="onCancelClick()" i18n="@@CancelButton">Schließen</button>
    <form [formGroup]="formService.form" (ngSubmit)="createPricingComponent.onSubmit(formService.form.value)">
      <button type="submit" id="add" class="btn btn-primary" [disabled]="!formService.form.valid || isSupporter" i18n="@@AddButton">Hinzufügen</button>
    </form>
  </div>
</div>
